<template>
  <div class="api-channel-code">
    <template v-if="isShowInput">
      <el-input class="code-input" v-model="currentValue" :size="size" placeholder="请输入" clearable :disabled="disabled"/>
    </template>
    <template v-else>
      <el-select class="code-select" v-model="currentValue" :size="size" placeholder="请选择" filterable clearable :disabled="disabled">
        <el-option
          v-for="(item,index) in list"
          :key="index"
          :label="item.code"
          :value="item.code"
        />
      </el-select>
    </template>
    <template v-if="canGet">
      <template v-if="loading">
        <el-button class="code-btn" :size="size" type="primary" disabled>正在获取（{{timeOutNumber}}）</el-button>
      </template>
      <template v-else-if="status === 0">
        <el-button class="code-btn" :size="size" type="primary" @click="clickGet">获取专线API渠道代码</el-button>
      </template>
      <template v-else-if="status === 1">
        <el-button class="code-btn" :size="size" type="success" disabled>获取成功</el-button>
      </template>
      <template v-else-if="status === 2">
        <el-button class="code-btn" :size="size" type="info" disabled>获取失败</el-button>
      </template>
    </template>
    <template v-else>

    </template>

  </div>
</template>

<script>
import {throttle} from "my-tools-kit";
export default {
  name: "selectApiChannelCode",
  props:{
    value:String,
    // 供应商编辑里是否勾选了是否可获取到专线API对接渠道代码
    canGet:Boolean,
    // 是否正在请求中
    loading:Boolean,
    // 获取状态  0-未请求  1-请求成功 2-请求失败
    status:{
      type:Number,
      default:0,
    },
    // 列表
    list:{
      type:Array,
      default:()=>[],
    },
    // 额外的尺寸： medium、small、mini
    size:String,
    timeOutNumber:Number,
    disabled:{
      type:Boolean,
      default:false,
    }
  },
  data(){
    return {
      currentValue:"",
    }
  },
  computed:{
    isShowInput(){
      if(this.canGet === true){
        if(this.status === 0) return false
        if(this.status === 1) return false
      }
      return true
    },
  },
  watch:{
    value(newVal){
      this.currentValue = newVal||"";
    },
    currentValue(newVal){
      this.emitChange(newVal||"");
    },
  },
  methods:{
    changeInput(val){
      this.emitChange(val);
    },
    changeSelect(val){
      this.emitChange(val);
    },
    changeClear(){
      this.emitChange();
    },
    emitChange:throttle(function (val){
      this.$emit("input",val);
      this.$emit("change",val);
    },100,false),
    clickGet(){
      this.$emit("clickBtn","get");
    },
  },
  created() {
    this.currentValue = this.value||"";
  },
}
</script>

<style scoped lang="less">
.api-channel-code{
  .code-input,
  .code-select{
    width: 400px;
  }
  .code-btn{
    width: 160px;
    height: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/selectApiChannelCode/index.vue